const remoteConfigDefaults = {
  isMaintenanceMwOn: 'false',
  textMaintenance:
    'Sizlere daha iyi hizmet verebilmek için bakımdayız. Lütfen biraz sonra tekrar deneyin.',
};

export default remoteConfigDefaults;
